import { useMutation } from '@tanstack/react-query'
import { postStandort } from '@/apis/Befehlsnachricht'
import { Befehlsnachricht, BfnStatus } from '@/models/Befehlsnachricht'
import { Standort } from '@repo/ui'
import { useBefehlsnachrichtUpdater } from '@/features/befehlsnachrichten/hooks/useBefehlsnachrichtUpdater'
import { useBfnStore } from '@/store/useBfnStore'
import { Abruftoken } from '@/models/Abruftoken'
import { validateBfnStatusChange } from '@/features/befehlsnachrichten/utils/befehlsnachricht-status'
import { useContext } from 'react'
import HinweisContext from '@/hooks/HinweisContext'
import BefehlsnachrichtStatusTransitionError from '@/features/befehlsnachrichten/errors/BefehlsnachrichtStatusTransitionError'

export default function useBfnStandortMutation(
  bfn: Befehlsnachricht,
  abruftoken: Abruftoken
) {
  const { setStandortSentDate } = useBfnStore()
  const updateBefehlsnachricht = useBefehlsnachrichtUpdater()
  const { setHinweis } = useContext(HinweisContext)

  const mutation = useMutation({
    mutationFn: async (standort: Standort) => {
      await postStandort(abruftoken, standort, bfn.id)
    },
    onSuccess: async () => {
      setStandortSentDate(bfn.id, new Date())
      const befehlsnachricht = await updateBefehlsnachricht(abruftoken)

      // validate that Befehlsnachricht status changed as expected
      try {
        validateBfnStatusChange(
          befehlsnachricht.status,
          BfnStatus.STANDORTABGLEICH_DURCH_FDL_ERFORDERLICH,
          befehlsnachricht.statusTimestamps
        )
      } catch (e) {
        setHinweis(
          'Unerwarteter Statuswechsel erkannt',
          (e as BefehlsnachrichtStatusTransitionError).message,
          'Bitte kontaktieren Sie den zuständigen Fahrdienstleiter.'
        )
      }
    }
  })

  return { mutation }
}
